import { type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { getIsWhiteboardSource } from './sources.ts';

export const submitSurveyFeedback = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	source:
		| 'importedPageFeedbackSurveyModal'
		| 'importedPageFeedbackBanner'
		| 'importedWhiteboardFeedbackSnackbar',
	importSource: string,
	importDate: Date,
	contentId: string,
	rating: 'positive' | 'negative',
	dataFormat?: string[] | undefined,
	feedback?: string | undefined,
): void => {
	createAnalyticsEvent({
		type: 'sendTrackEvent',
		data: {
			action: 'submitted',
			actionSubject: 'survey',
			actionSubjectId: 'importFeedbackSurvey',
			source,
			attributes: {
				rating,
				dataFormat,
				feedback,
				importType: importSource,
				importDate: importDate.toISOString(),
				contentType: getIsWhiteboardSource(importSource) ? 'whiteboard' : 'page',
				contentId,
			},
		},
	}).fire();
};
